import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

/** 스피너 회전 애니메이션 — transform-only, GPU 합성 */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

/** 본문 영역 가운데 정렬 컨테이너. 검색 인풋 아래 flex로 채움 */
export const SpinnerWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
`

/**
 * 32px 원형 스피너 — brand orange 호 + 투명 배경.
 * `border` 트릭으로 SVG 없이 가벼움.
 */
export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid #f5f5f6;
  border-top-color: #ff5626;
  animation: ${spin} 0.7s linear infinite;
  will-change: transform;
`
